import _capitalize from 'lodash/capitalize';
const updatePaymentsInfoFormatHelper = function (paymentsInfo, additionalData) {
  if (paymentsInfo === void 0) {
    paymentsInfo = {};
  }
  const {
    activeTab,
    financePayment,
    leasePayment,
    downPayment
  } = additionalData;
  let termLength;
  let monthlyPayment;
  if (activeTab === 'finance') {
    termLength = paymentsInfo.loanTerm;
    monthlyPayment = financePayment || paymentsInfo.monthlyPayment;
  } else if (activeTab === 'lease') {
    termLength = paymentsInfo.leaseTerm;
    monthlyPayment = leasePayment;
  }
  return {
    deal: {
      downPayment: downPayment?.toString() || paymentsInfo.downPayment?.toString(),
      monthlyPayment: monthlyPayment?.toString(),
      paymentMethod: _capitalize(activeTab),
      termLength: termLength?.toString()
    },
    tradeIn: {
      condition: paymentsInfo.tradeIn?.condition,
      payoff: paymentsInfo.tradeIn?.amountOwed?.toString(),
      valuation: paymentsInfo.tradeIn?.value?.toString(),
      source: paymentsInfo.tradeIn?.source?.toLowerCase()
    }
  };
};
export default updatePaymentsInfoFormatHelper;